import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Account = {
  __typename?: 'Account';
  appId?: Maybe<Scalars['UUID4']>;
  credits: Array<Credit>;
  id?: Maybe<Scalars['UUID4']>;
  invoicing?: Maybe<Invoicing>;
  name?: Maybe<Scalars['String']>;
  sapLink?: Maybe<SapLink>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  type: Scalars['String'];
};


export type AccountSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
  user: User;
  zip: Scalars['String'];
};

export type AddressConfig = {
  __typename?: 'AddressConfig';
  countriesAllowed: Array<CountriesAllowed>;
  note?: Maybe<Scalars['String']>;
  requireValidation: ValidationRequirement;
  statesConfig: Array<StatesConfig>;
};

export type AllowedState = {
  __typename?: 'AllowedState';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AnalyticsConfig = {
  __typename?: 'AnalyticsConfig';
  gtm?: Maybe<GtmConfig>;
  projectId?: Maybe<Scalars['String']>;
  writeKey?: Maybe<Scalars['String']>;
};

export type Bazaarvoice = {
  __typename?: 'Bazaarvoice';
  encryptedEmail?: Maybe<Scalars['String']>;
  encryptionKeyId?: Maybe<Scalars['String']>;
};

export type BraintreeAddress = {
  __typename?: 'BraintreeAddress';
  company?: Maybe<Scalars['String']>;
  countryCodeAlpha2?: Maybe<Scalars['String']>;
  countryCodeAlpha3?: Maybe<Scalars['String']>;
  countryCodeNumeric?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  extendedAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BrandConfig = {
  __typename?: 'BrandConfig';
  audience: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  copyright: Scalars['String'];
  customCss?: Maybe<Scalars['String']>;
  customizations: BrandConfigCustomizations;
  email?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  optInText: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trackingFonts?: Maybe<Array<Maybe<BrandConfigTrackingFonts>>>;
  yearsAgeGate?: Maybe<Scalars['Int']>;
};

export type BrandConfigCustomizations = {
  __typename?: 'BrandConfigCustomizations';
  contacts: Array<BrandConfigCustomizationsContact>;
  css: Array<BrandConfigCustomizationsCss>;
  fonts: Array<BrandConfigCustomizationsFont>;
  images: Array<BrandConfigCustomizationsImage>;
  links: Array<BrandConfigCustomizationsLink>;
};

export type BrandConfigCustomizationsContact = {
  __typename?: 'BrandConfigCustomizationsContact';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsCss = {
  __typename?: 'BrandConfigCustomizationsCss';
  overrides: Array<BrandConfigCustomizationsCssOverride>;
  selector: Scalars['String'];
};

export type BrandConfigCustomizationsCssOverride = {
  __typename?: 'BrandConfigCustomizationsCssOverride';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFont = {
  __typename?: 'BrandConfigCustomizationsFont';
  meta?: Maybe<Array<BrandConfigCustomizationsFontMeta>>;
  name: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  urls: Array<BrandConfigCustomizationsFontSources>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsFontMeta = {
  __typename?: 'BrandConfigCustomizationsFontMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFontSources = {
  __typename?: 'BrandConfigCustomizationsFontSources';
  format?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsImage = {
  __typename?: 'BrandConfigCustomizationsImage';
  alt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  src: Scalars['String'];
};

export type BrandConfigCustomizationsLink = {
  __typename?: 'BrandConfigCustomizationsLink';
  location: Scalars['String'];
  newTab: Scalars['Boolean'];
  position: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BrandConfigTrackingFonts = {
  __typename?: 'BrandConfigTrackingFonts';
  font: Scalars['String'];
  isTrackingRequired: Scalars['Boolean'];
  resource: Scalars['String'];
};

export type BundleItem = {
  __typename?: 'BundleItem';
  imgUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CalculateOrderDiscountsInput = {
  orderId?: InputMaybe<Scalars['UUID4']>;
  price?: InputMaybe<PriceInput>;
};

export type CalculateOrderDiscountsPayload = {
  __typename?: 'CalculateOrderDiscountsPayload';
  order?: Maybe<Order>;
};

export type CalculateOrderPayload = {
  __typename?: 'CalculateOrderPayload';
  order?: Maybe<Order>;
};

export type CancelOrderSubscriptionInput = {
  cancelReason: Scalars['String'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type Capabilities = {
  __typename?: 'Capabilities';
  signUp: CapabilitiesSignUp;
};

/**
 * The sign up capability informs consumers of the API if the Tenant
 * allows users to sign up via the Secure Portal.
 */
export type CapabilitiesSignUp = {
  __typename?: 'CapabilitiesSignUp';
  enabled: Scalars['Boolean'];
};

export type Cart = {
  __typename?: 'Cart';
  appId: Scalars['UUID4'];
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  items: Array<CartItem>;
  user?: Maybe<User>;
  vendorConfig: Tenant;
};

export type CartItem = {
  __typename?: 'CartItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  customizations?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  item: Item;
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
};

export type CartItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type Category = {
  __typename?: 'Category';
  appId: Scalars['UUID4'];
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type Checkout = {
  __typename?: 'Checkout';
  paymentOptions?: Maybe<TenantPaymentOptions>;
};

export type ContactConfig = {
  __typename?: 'ContactConfig';
  shippingAddressConfig: AddressConfig;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  bazaarvoice?: Maybe<Bazaarvoice>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<EmbeddedAddress>;
  user?: Maybe<User>;
  username?: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<EmbeddedAddressInput>;
  username?: InputMaybe<Scalars['String']>;
};

export type CountriesAllowed = {
  __typename?: 'CountriesAllowed';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePaymentMethodInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData: Scalars['String'];
  nonce: Scalars['String'];
};

/** Response when an order is created during checkout */
export type CreatedOrder = {
  __typename?: 'CreatedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  contactInfo?: Maybe<ContactInfo>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submissionUid?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Credit = {
  __typename?: 'Credit';
  activeFrom: Scalars['Date'];
  activeUntil?: Maybe<Scalars['Date']>;
  availableAmount: Scalars['Int'];
  frozen: Scalars['Boolean'];
  id: Scalars['UUID4'];
  notes?: Maybe<Scalars['String']>;
  pendingAmount: Scalars['Int'];
  settledAmount: Scalars['Int'];
  spentAmount: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress?: Maybe<BraintreeAddress>;
  cardType: Scalars['String'];
  cardholderName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  last4: Scalars['String'];
  token: Scalars['String'];
  uniqueNumberIdentifier: Scalars['String'];
};

export type DeleteCreditCardInput = {
  token: Scalars['String'];
};

export type DeletePaymentMethodInput = {
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  activeFrom: Scalars['DateTime'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['UUID4']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: Maybe<Scalars['Boolean']>;
  isPromoCodeRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  type?: Maybe<DiscountType>;
  typeDependentValue?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
};

export enum DiscountType {
  /** Currently unused */
  GiftCard = 'GIFT_CARD',
  /** The discount is specific to a single item */
  Item = 'ITEM',
  /** The discount is specific to the discount's itemSet */
  ItemSet = 'ITEM_SET',
  /** The discount is specific to an entire tenant */
  Tenant = 'TENANT',
  /** The discount is specific to a specific vendor */
  Vendor = 'VENDOR'
}

export type Discounts = {
  __typename?: 'Discounts';
  discounts?: Maybe<Array<Discount>>;
};

export type DiscountsInput = {
  activeFrom: Scalars['DateTime'];
  activeUntil?: InputMaybe<Scalars['DateTime']>;
  amount?: InputMaybe<Scalars['Int']>;
  appId?: InputMaybe<Scalars['UUID4']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: InputMaybe<Scalars['Boolean']>;
  isPromoCodeRequired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeDependentValue?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['Int']>;
};

export type EmailNewsletterSignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  source?: InputMaybe<SourceType>;
};

export type EmailSspInput = {
  businessAddress: Scalars['String'];
  businessName: Scalars['String'];
  businessType: Scalars['String'];
  city: Scalars['String'];
  emailField: Scalars['String'];
  existingCustomer: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  manageAndOrder: Scalars['String'];
  numberOfUsers: Scalars['String'];
  phoneNumber: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type EmailSspResponse = {
  __typename?: 'EmailSspResponse';
  status: Scalars['String'];
};

export type EmbeddedAddress = {
  __typename?: 'EmbeddedAddress';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type EmbeddedAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EmbeddedCategory = {
  __typename?: 'EmbeddedCategory';
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type EmbeddedDiscount = {
  __typename?: 'EmbeddedDiscount';
  amount?: Maybe<Scalars['Int']>;
  isPercent?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedItem = {
  __typename?: 'EmbeddedItem';
  awaitingImportCorrection?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  categories?: Maybe<EmbeddedCategory>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  imgUrl?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['UUID4']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  subscriptionMetadata?: Maybe<EmbeddedItemSubscriptionMetadata>;
  tags?: Maybe<Scalars['String']>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['UUID4']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type EmbeddedItemSubscriptionMetadata = {
  __typename?: 'EmbeddedItemSubscriptionMetadata';
  discount?: Maybe<EmbeddedDiscount>;
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type FieldMeasure = {
  __typename?: 'FieldMeasure';
  eqv?: Maybe<Scalars['Int']>;
  eunit?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  carrierName?: Maybe<Scalars['String']>;
  externalFulfillmentId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  items: Array<FulfillmentItem>;
  orderId?: Maybe<Scalars['UUID4']>;
  status?: Maybe<Scalars['String']>;
  taxServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  tracking?: Maybe<TrackingNumber>;
  trackingNumber?: Maybe<Scalars['String']>;
  /** @deprecated Prefer the "tracking" field which returns single tracking number info. */
  trackingNumbers: Array<TrackingNumber>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type FulfillmentItem = {
  __typename?: 'FulfillmentItem';
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  quantity?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type GetNutrientDetailInput = {
  gtins: Array<InputMaybe<Scalars['String']>>;
};

export type GiftConfig = {
  __typename?: 'GiftConfig';
  giftEmailConfig?: Maybe<GiftEmailConfig>;
  giftingEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftEmailConfig = {
  __typename?: 'GiftEmailConfig';
  centralImageUrl?: Maybe<Scalars['String']>;
  footerCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
};

export type GtmConfig = {
  __typename?: 'GtmConfig';
  auth?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

export type InvoicedAddress = {
  __typename?: 'InvoicedAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  id: Scalars['UUID4'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type Invoicing = {
  __typename?: 'Invoicing';
  addresses: Array<InvoicedAddress>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type IsGiftInput = {
  id: Scalars['UUID4'];
  isGift: Scalars['Boolean'];
};

export type Item = {
  __typename?: 'Item';
  appId: Scalars['UUID4'];
  brandName?: Maybe<Scalars['String']>;
  caloriesPerPack?: Maybe<Scalars['Decimal']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice: Scalars['Int'];
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gtin: Scalars['String'];
  height?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  imgUrl?: Maybe<Scalars['String']>;
  imgVariantUrls?: Maybe<Array<Maybe<ProductImageVariant>>>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending: Scalars['Boolean'];
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  nutritionData?: Maybe<NutritionData>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  recommendedItems: Array<Item>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Please use `slug` going forward. */
  slugHash?: Maybe<Scalars['String']>;
  stories?: Maybe<Array<Maybe<Story>>>;
  subItems?: Maybe<Array<Maybe<BundleItem>>>;
  subscriptionMetadata?: Maybe<ItemSubscriptionMetadata>;
  sugarGramsPerPack?: Maybe<Scalars['Decimal']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated, use `Gtin` in place of `Upc` */
  upc?: Maybe<Scalars['String']>;
  variantOptions?: Maybe<Array<Maybe<ProductVariant>>>;
  vendorConfig: Tenant;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type ItemSubscriptionMetadata = {
  __typename?: 'ItemSubscriptionMetadata';
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice: Scalars['Int'];
};

export type ItemsInput = {
  basePrice?: InputMaybe<Scalars['Int']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['UUID4']>;
  itemId?: InputMaybe<Scalars['UUID4']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingAmount?: InputMaybe<Scalars['Int']>;
  taxAmount?: InputMaybe<Scalars['Int']>;
};

export type ItemsPayload = {
  __typename?: 'ItemsPayload';
  items: Array<Item>;
  pagination: PaginationData;
};

export type LatLong = {
  __typename?: 'LatLong';
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Module = {
  __typename?: 'Module';
  body?: Maybe<Scalars['String']>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  isApproved?: Maybe<Scalars['Boolean']>;
  itemOrdering: Array<ModuleItem>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedTime?: Maybe<Scalars['String']>;
  story?: Maybe<Story>;
  storySlug: Scalars['String'];
  thumbnailItems: Array<ModuleThumbnailItem>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  urlOverride?: Maybe<Scalars['String']>;
};

export type ModuleItem = {
  __typename?: 'ModuleItem';
  item?: Maybe<Item>;
  module?: Maybe<Module>;
  order?: Maybe<Scalars['Int']>;
};

export type ModuleThumbnailItem = {
  __typename?: 'ModuleThumbnailItem';
  id?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type NutrientDetail = {
  __typename?: 'NutrientDetail';
  brandName?: Maybe<Scalars['String']>;
  calciumDailyValuePercentage?: Maybe<Scalars['Float']>;
  calories?: Maybe<UnitAmount>;
  caloriesPerPack?: Maybe<Scalars['Float']>;
  carbohydrates?: Maybe<UnitAmount>;
  description?: Maybe<Scalars['String']>;
  fat?: Maybe<UnitAmount>;
  fluidOzPerPack?: Maybe<Scalars['Float']>;
  gtin?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  potassium?: Maybe<UnitAmount>;
  productName?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  protein?: Maybe<UnitAmount>;
  servingSize?: Maybe<UnitAmount>;
  sodium?: Maybe<UnitAmount>;
  sugarGramsPerPack?: Maybe<Scalars['Float']>;
  vitaminB6DailyValuePercentage?: Maybe<Scalars['Float']>;
};

export type NutrientDetailInput = {
  gtin: Scalars['String'];
};

export type NutritionData = {
  __typename?: 'NutritionData';
  code?: Maybe<Scalars['String']>;
  ingredientsTextEn?: Maybe<Scalars['String']>;
  nutrients?: Maybe<Array<Maybe<NutritionField>>>;
};

export type NutritionField = {
  __typename?: 'NutritionField';
  derivation?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  measures?: Maybe<Array<Maybe<FieldMeasure>>>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  contactInfo: ContactInfo;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OrderInput = {
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
};

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  address: Address;
  /** @deprecated Please use status/status_reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** @deprecated Please use status_updated_at */
  canceledAt?: Maybe<Scalars['Date']>;
  id: Scalars['UUID4'];
  initialOrderDate?: Maybe<Scalars['DateTime']>;
  insertedAt: Scalars['DateTime'];
  intervalInDays: Scalars['Int'];
  lastOrderAttempt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Please use last_successful_order_date */
  lastSuccessfulOrder: Scalars['Date'];
  lastSuccessfulOrderDate: Scalars['Date'];
  /** @deprecated Please use next_order_creation_date */
  nextDeliveryDate: Scalars['Date'];
  nextOrderCreationDate: Scalars['Date'];
  orderSubscriptionItems: Array<OrderSubscriptionItem>;
  originatingOrder?: Maybe<SubmittedOrder>;
  paymentInfo: PaymentInfo;
  status: OrderSubscriptionStatusNames;
  statusReason?: Maybe<Scalars['String']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  vendorConfig: Tenant;
};

export type OrderSubscriptionItem = {
  __typename?: 'OrderSubscriptionItem';
  orderSubscription: OrderSubscription;
  priceItem: PriceItem;
};

export enum OrderSubscriptionRelationshipNames {
  /** Order that was a direct result of a subscription execution */
  Child = 'CHILD',
  /** Order with no relationship to any subscriptions */
  None = 'NONE',
  /** Order that resulted in subscriptions being made (priceItem had > 0 subscription_interval_in_days values) */
  Parent = 'PARENT'
}

export enum OrderSubscriptionStatusNames {
  /** Subscription is active and in valid state to fulfill */
  Active = 'ACTIVE',
  /** Subscription is canceled for reason stated in `status_reason` */
  Canceled = 'CANCELED',
  /** Subscription is paused for reason stated in `status_reason` */
  Paused = 'PAUSED'
}

export type OrderSubscriptionsPayload = {
  __typename?: 'OrderSubscriptionsPayload';
  orderSubscriptions: Array<OrderSubscription>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  count: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaymentClientTokenPayload = {
  __typename?: 'PaymentClientTokenPayload';
  token: Scalars['String'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  billingAddressConfig: AddressConfig;
  descriptor?: Maybe<Scalars['String']>;
  paymentTypes: Array<PaymentType>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNames>;
  paymentType?: Maybe<Scalars['String']>;
  paypalEmail?: Maybe<Scalars['String']>;
  uniqueNumberIdentifier?: Maybe<Scalars['String']>;
};

/** object for holding a single default payment method */
export type PaymentMethod = CreditCard | PaypalAccount;

export enum PaymentMethodNames {
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** Paypal Account */
  Paypal = 'PAYPAL'
}

/** object defined to hold the different payment methods */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  creditCards?: Maybe<Array<CreditCard>>;
  default?: Maybe<PaymentMethod>;
  paypalAccounts?: Maybe<Array<PaypalAccount>>;
};

export type PaymentOptionsInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData?: InputMaybe<Scalars['String']>;
  nonce?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  billingAddress?: Maybe<EmbeddedAddress>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type PaymentRequestInput = {
  billingAddress?: InputMaybe<EmbeddedAddressInput>;
  deviceData?: InputMaybe<Scalars['String']>;
  isBillingEqualShipping?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  saveCardForLater?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PaypalAccount = {
  __typename?: 'PaypalAccount';
  billingAgreementId: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  email: Scalars['String'];
  imageUrl: Scalars['String'];
  isChannelInitated?: Maybe<Scalars['Boolean']>;
  payerInfo?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  discount?: Maybe<Scalars['Int']>;
  discounts: Array<Discount>;
  id?: Maybe<Scalars['UUID4']>;
  items: Array<PriceItem>;
  priceDiscounts: Array<PriceDiscount>;
  shipping?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  total?: Maybe<Scalars['Int']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  discount?: Maybe<Discount>;
  price?: Maybe<Price>;
};

export type PriceInput = {
  discount?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Array<InputMaybe<DiscountsInput>>>;
  items?: InputMaybe<Array<InputMaybe<ItemsInput>>>;
  shipping?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  basePrice?: Maybe<Scalars['Int']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** Item in it's current state (may differ from embedded item) */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  discountAmount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  itemId?: Maybe<Scalars['UUID4']>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated This field should not be used nor relied upon */
  shippingAmount?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type ProductImageVariant = {
  __typename?: 'ProductImageVariant';
  item?: Maybe<Item>;
  pos?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  item?: Maybe<Item>;
  variant?: Maybe<Item>;
  variantOptions?: Maybe<Array<Maybe<ProductVariantOption>>>;
};

export type ProductVariantOption = {
  __typename?: 'ProductVariantOption';
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  productVariant?: Maybe<ProductVariant>;
  value?: Maybe<Scalars['String']>;
};

/**
 * Inputs for requesting Password Reset for a User.
 *
 * The `state` field is used to pass information back to the browser when
 * as User clicks on the password reset link in their email. The state is
 * included as a query string appended to the URL. The value of `state` can
 * be any string, as long as it is URL safe.
 *
 * The API does not inspect or manipulate the `state`, it is simply passed
 * to the password reset link.
 */
export type RequestPasswordResetForUserInput = {
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type RequestPasswordResetForUserPayload = {
  __typename?: 'RequestPasswordResetForUserPayload';
  email: Scalars['String'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  token: Scalars['String'];
};

export type RestrictedItemsByZipCodePayload = {
  __typename?: 'RestrictedItemsByZipCodePayload';
  restrictedItems: Array<Item>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /**
   * Adds an item to a cart. Will create a new cart
   * if no `id` is included and cart is not already
   * associated with the requesting user. If a cart
   * already exists for the user or session we will
   * grab that cart and add the requested item.
   *
   * Cookie for cart is `decovo-shoppingcart`.
   *
   * Example:
   *   ```
   *   mutation AddCartItem($input: CartItemInput!) {
   *     addCartItem(input: $input) {
   *       id
   *       items {
   *         id
   *         quantity
   *         customizations
   *       }
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     input: {
   *       "item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "quantity": 1
   *     }
   *   }
   *   ```
   */
  addCartItem?: Maybe<Cart>;
  /**
   * associates an anonymous Cart (a Cart without a `user_id`) to the current
   * authenticated User.
   */
  associateCartToUser?: Maybe<Cart>;
  /** Returns the order with the discounts applied. (Does not update order in DB) */
  calculateOrderDiscounts?: Maybe<CalculateOrderDiscountsPayload>;
  calculateOrderTaxes?: Maybe<CalculateOrderPayload>;
  /** @deprecated Please use update_order_subscription_status and set status to CANCELED and include a status_reason */
  cancelOrderSubscription?: Maybe<OrderSubscription>;
  changeUserPassword?: Maybe<User>;
  /**
   * Creates an order.
   *
   * Mutation
   * ```
   * mutation CreateOrder($cartId: String!, $input: OrderInput) {
   *   createOrder(cartId: $cartId, input: $input) {
   *     app_id
   *     cart{
   *         id
   *     }
   *     id
   *     status
   *     location {
   *       lat
   *       long
   *     }
   *     user {
   *       id
   *       first_name
   *       last_name
   *     }
   *     contact_info {
   *         email
   *         shipping_address{
   *             line1
   *         }
   *     }
   *     payment_request{
   *         billing_address{
   *             line1
   *         }
   *     }
   *     price{
   *         total
   *     }
   *     requested_delivery_date
   *     submission_uid
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "cartId": "bcde7722-bf35-4a41-bc56-b200ec3155ae",
   *   "input": {}
   * }
   * ```
   */
  createOrder?: Maybe<CreatedOrder>;
  createPaymentClientToken: PaymentClientTokenPayload;
  createPaymentMethod: PaymentMethod;
  createUserAddress: Address;
  deleteCreditCard: Scalars['String'];
  deletePaymentMethod: Scalars['String'];
  deleteUserAddress: Address;
  emailNewsletterSignup?: Maybe<Scalars['String']>;
  /** @deprecated Please use`loginUser` going forward. */
  login?: Maybe<User>;
  loginUser?: Maybe<User>;
  logoutUser?: Maybe<User>;
  /**
   * Requests a Password Reset for a User with the email provided.
   *
   * Mutation
   * ```
   * mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
   *   requestPasswordResetForUser(input: $input) {
   *     email
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "email": "user@example.com"
   *   }
   * }
   * ```
   */
  requestPasswordResetForUser?: Maybe<RequestPasswordResetForUserPayload>;
  /**
   * This Mutation has been deprecated, please use `requestPasswordResetForUser`
   * @deprecated This Mutation has been deprecated, please use `requestPasswordResetForUser`
   *
   */
  requestUserPasswordReset?: Maybe<UserPasswordResetRequestPayload>;
  resetUserPassword?: Maybe<User>;
  /**
   * Example:
   *   ```
   *   mutation SendSspEmail($input: EmailSspInput!) {
   *     sendSspEmail(input: $input) {
   *       status
   *     }
   *   }
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input":{
   *       "firstName":"First name",
   *       "lastName":"Last name",
   *       "email":"email@pepsico.com",
   *       "businessName":"Pepsico",
   *       "businessAddress":"Business address",
   *       "businessType":"Business Type",
   *       "numberOfUsers":10,
   *       "existingCustomer": true,
   *       "manageAndOrder": "Manage and order",
   *       "city": "Benito Juarez",
   *       "state": "CDMX",
   *       "zip": "03023",
   *       "phone_number": "5512259112"
   *     }
   *   }
   *   ```
   */
  sendSspEmail?: Maybe<EmailSspResponse>;
  /** @deprecated Please use `signupUser` going forward. */
  signup?: Maybe<User>;
  signupUser?: Maybe<User>;
  skipOrderSubscription?: Maybe<OrderSubscription>;
  /**
   * Submits an order, returning the created submittedOrder.
   *
   * Mutation
   * ```
   * mutation SubmitOrder($orderId: UUID4!, $input: SubmitOrderInput!) {
   *   submitOrder(orderId: $orderId, input: $input) {
   *     app_id
   *     cart_id
   *     giftee_email
   *     giftee_message
   *     giftor_name
   *     is_gift
   *     price {
   *       discount
   *     }
   *     user {
   *       email
   *       first_name
   *       last_name
   *     }
   *     status
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   input: {
   *     contactInfo: {
   *       email: "tyrell1971@hoppe.name",
   *       phone: "5555555555",
   *       shippingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "country",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       }
   *     },
   *     paymentRequest: {
   *       billingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "US",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       },
   *       isBillingEqual_shipping: false,
   *       paymentMethod: "CREDIT_CARD",
   *       paymentToken: "token"
   *     },
   *     price: {discounts: []},
   *     requestedDeliveryDate: ~D[2021-10-05]
   *   },
   *   orderId: "e1215198-69be-4eb3-8e95-8ad441ebfe0a"
   * }
   * ```
   */
  submitOrder?: Maybe<SubmittedOrder>;
  updateCartGift?: Maybe<Cart>;
  updateCartItem?: Maybe<Cart>;
  updateCreditCardDefault: CreditCard;
  /**
   * Updates an order.
   *
   * Mutation
   * ```
   * mutation UpdateOrder($orderId: UUID4!, $input: UpdateOrderInput!) {
   *   updateOrder(orderId: $orderId, input: $input) {
   *     id
   *     appId
   *     requestedDeliveryDate
   *     contactInfo {
   *       email
   *       phone
   *       shippingAddress {
   *         city
   *         zip
   *       }
   *     }
   *     paymentRequest {
   *       paymentMethod
   *       isBillingEqualShipping
   *       billingAddress {
   *         city
   *         zip
   *       }
   *     }
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "order_id": "3965354a-260c-4fdd-a0d5-75f6efee4207",
   *   "input": {}
   * }
   * ```
   */
  updateOrder?: Maybe<CreatedOrder>;
  updateOrderSubscription?: Maybe<OrderSubscription>;
  updateOrderSubscriptionAddress?: Maybe<OrderSubscription>;
  updateOrderSubscriptionPayment?: Maybe<OrderSubscription>;
  updateOrderSubscriptionStatus?: Maybe<OrderSubscription>;
  updatePaymentMethodDefault: PaymentMethod;
  updateUserAddress: Address;
  updateUserAddressIsDefault: Address;
  /**
   * mutation UserAddressVerification {
   *     userAddressVerification(
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  userAddressVerification?: Maybe<VerifyAddressPayload>;
  /**
   * mutation AddressVerification {
   *     verifyAddressForOrder(
   *       orderId: "",
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         special_instructions: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       special_instructions,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  verifyAddressForOrder?: Maybe<VerifyAddressPayload>;
};


export type RootMutationTypeAddCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeAssociateCartToUserArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeCalculateOrderDiscountsArgs = {
  input: CalculateOrderDiscountsInput;
};


export type RootMutationTypeCalculateOrderTaxesArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  orderId?: InputMaybe<Scalars['UUID4']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  price?: InputMaybe<PriceInput>;
};


export type RootMutationTypeCancelOrderSubscriptionArgs = {
  input?: InputMaybe<CancelOrderSubscriptionInput>;
};


export type RootMutationTypeChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type RootMutationTypeCreateOrderArgs = {
  cartId: Scalars['String'];
  input?: InputMaybe<OrderInput>;
};


export type RootMutationTypeCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type RootMutationTypeCreateUserAddressArgs = {
  input: UserAddressInput;
};


export type RootMutationTypeDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type RootMutationTypeDeletePaymentMethodArgs = {
  input: DeletePaymentMethodInput;
};


export type RootMutationTypeDeleteUserAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeEmailNewsletterSignupArgs = {
  input: EmailNewsletterSignupInput;
};


export type RootMutationTypeLoginArgs = {
  input: LoginInput;
};


export type RootMutationTypeLoginUserArgs = {
  input: LoginUserInput;
};


export type RootMutationTypeRequestPasswordResetForUserArgs = {
  input: RequestPasswordResetForUserInput;
};


export type RootMutationTypeRequestUserPasswordResetArgs = {
  email: Scalars['String'];
};


export type RootMutationTypeResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type RootMutationTypeSendSspEmailArgs = {
  input: EmailSspInput;
};


export type RootMutationTypeSignupArgs = {
  input: SignupInput;
};


export type RootMutationTypeSignupUserArgs = {
  input: SignupUserInput;
};


export type RootMutationTypeSkipOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeSubmitOrderArgs = {
  input?: InputMaybe<SubmitOrderInput>;
  orderId: Scalars['String'];
};


export type RootMutationTypeUpdateCartGiftArgs = {
  input: IsGiftInput;
};


export type RootMutationTypeUpdateCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeUpdateCreditCardDefaultArgs = {
  input: UpdateCreditCardDefaultInput;
};


export type RootMutationTypeUpdateOrderArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateOrderSubscriptionArgs = {
  input: UpdateOrderSubscriptionInput;
};


export type RootMutationTypeUpdateOrderSubscriptionAddressArgs = {
  input: UpdateOrderSubscriptionAddressInput;
};


export type RootMutationTypeUpdateOrderSubscriptionPaymentArgs = {
  input: UpdateOrderSubscriptionPaymentInput;
};


export type RootMutationTypeUpdateOrderSubscriptionStatusArgs = {
  input: UpdateOrderSubscriptionStatusInput;
};


export type RootMutationTypeUpdatePaymentMethodDefaultArgs = {
  input: UpdatePaymentMethodDefaultInput;
};


export type RootMutationTypeUpdateUserAddressArgs = {
  id: Scalars['UUID4'];
  input: UserAddressInput;
};


export type RootMutationTypeUpdateUserAddressIsDefaultArgs = {
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
};


export type RootMutationTypeUserAddressVerificationArgs = {
  input: VerifyAddressInput;
};


export type RootMutationTypeVerifyAddressForOrderArgs = {
  input: VerifyAddressInput;
  orderId: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Gets the currently active account
   * Example:
   *   ```
   *   query {
   *     activeAccount {
   *       type
   *       credits {
   *         status
   *         type
   *         availableAmount
   *         spentAmount
   *         activeFrom
   *         activeUntil
   *       }
   *     }
   *   }
   *   ```
   */
  activeAccount?: Maybe<Account>;
  /** Retrieves a cart given an id */
  cart?: Maybe<Cart>;
  /** Retrieves a cart given a hashed email for Salesforce */
  cartRecovery?: Maybe<Cart>;
  /**
   * Gets the currently logged in user
   * Example:
   *   ```
   *   query {
   *     currentUser {
   *       email
   *       firstName
   *       lastName
   *       creditCards {
   *         cardholderName
   *         billingAddress{
   *           firstName
   *           lastName
   *         }
   *       }
   *       addresses{
   *         line1
   *         line2
   *       }
   *     }
   *   }
   *   ```
   */
  currentUser?: Maybe<User>;
  /** Lookup all Feature Flags. If a `User` is logged in, the Feature Flags will reflect `User` specific Feature Flags. */
  featureFlags: Array<FeatureFlag>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `items` going forward.
   */
  getItems?: Maybe<ItemsPayload>;
  /**
   * Returns an `Item` for the given `GTIN`.
   *
   * Example
   * ```
   * query ItemByGtin($gtin: String!) {
   *   itemByGtin(gtin: $gtin) {
   *     id
   *     description
   *     title
   *   }
   * }
   *
   * {"gtin": "000111222333444555}
   * ```
   */
  itemByGtin?: Maybe<Item>;
  /**
   * Return the item by its id
   * Example:
   *   ```
   *   query itemById($id: String!) {
   *     itemById(id: $id) {
   *       id
   *       description
   *     }
   *   }
   *  {"id": "id"}
   *   ```
   */
  itemById?: Maybe<Item>;
  /**
   * Return the item by its slug
   * Example:
   *   ```
   *   query itemBySlug($slug: String!) {
   *     itemBySlug(slug: $slug) {
   *       id
   *       description
   *     }
   *   }
   *  {"slug": "slug"}
   *   ```
   */
  itemBySlug?: Maybe<Item>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  items?: Maybe<ItemsPayload>;
  modules: Array<Module>;
  nutrientDetail?: Maybe<NutrientDetail>;
  nutrientDetails?: Maybe<Array<Maybe<NutrientDetail>>>;
  /**
   * Return a single order filtered by id
   * Example:
   *   ```
   *   query OrderQueries {
   *     order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  order?: Maybe<Order>;
  /**
   * query getOrderSubscriptionForUser($id: UUID4!) {
   *   orderSubscription(id: $id) {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       priceItem {
   *         basePrice
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscription?: Maybe<OrderSubscription>;
  /**
   * query getAllOrderSubscriptionsForUser {
   *   orderSubscriptions {
   *     orderSubscriptions {
   *       id
   *       title
   *       intervalInDays
   *       orderSubscriptionItems {
   *         priceItem {
   *           basePrice
   *           id
   *         }
   *       }
   *     }
   *   }
   * }
   */
  orderSubscriptions?: Maybe<OrderSubscriptionsPayload>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query RestrictedItemsByZipCode {
   *     restrictedItemsByZipCode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  restrictedItemsByZipCode?: Maybe<RestrictedItemsByZipCodePayload>;
  /**
   * Searchs and displays an application's list of
   * discounts which meet certain requirements.
   *
   * typeDependentValue. It can be one of the following values:
   * - vendor_id
   * - item_id
   * - app_id
   *
   * type. It can be one of the following values:
   * - BRAND
   * - PRODUCT
   * - VENDOR
   *
   * Query
   *
   *   ```
   *   query SearchDiscounts($input: SearchDiscountsInput!) {
   *     searchDiscounts(input: $input) {
   *       discounts{
   *         id
   *         activeFrom
   *         activeUntil
   *         amount
   *         appId
   *         isPercent
   *         isPromoCodeRequired
   *         limit
   *         promoCode
   *         type
   *         typeDependentValue
   *         usage
   *       }
   *     }
   *   }
   *   ```
   *
   *   Variables
   *
   *   ```
   *   {
   *     input: {
   *       "typeDependentValue": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "type": "item",
   *       "promoCode": "PROMOCODE"
   *     }
   *   }
   *   ```
   */
  searchDiscounts?: Maybe<Discounts>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   */
  story?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyById"
   */
  storyById?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `slug`.
   *
   * Example:
   * ```
   * query StoryBySlug($slug: String!) {
   *   story: storyBySlug(slug: $slug) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyBySlug"
   */
  storyBySlug?: Maybe<Story>;
  /**
   * Return a single submitted order filtered by id
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  submittedOrder?: Maybe<SubmittedOrder>;
  /**
   * Return a list of orders, paginated, for the current user
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_orders(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       orders_count
   *       submitted_orders {
   *       id
   *       }
   *     }
   *   }
   *   ```
   */
  submittedOrders: SubmittedOrderPayload;
  /**
   * Return the `Tenant` associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     tenant {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   */
  tenant?: Maybe<Tenant>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query validateZipcode {
   *     validateZipcode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `restrictedItemsByZipCode` going forward.
   */
  validateZipcode?: Maybe<ValidateZipcodePayload>;
  /**
   * Deprecated in favor or `tenant`.
   *
   * Return the VendorConfig associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     vendorConfig {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   * @deprecated This Query has been deprecated in favor of `tenant`.
   *
   *
   */
  vendorConfig?: Maybe<Tenant>;
};


export type RootQueryTypeCartArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCartRecoveryArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeGetItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemByGtinArgs = {
  gtin: Scalars['String'];
};


export type RootQueryTypeItemByIdArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeItemBySlugArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeNutrientDetailArgs = {
  input: NutrientDetailInput;
};


export type RootQueryTypeNutrientDetailsArgs = {
  input?: InputMaybe<GetNutrientDetailInput>;
};


export type RootQueryTypeOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeRestrictedItemsByZipCodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};


export type RootQueryTypeSearchDiscountsArgs = {
  input: SearchDiscountsInput;
};


export type RootQueryTypeStoryArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryByIdArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type RootQueryTypeSubmittedOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeValidateZipcodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};

export type SapLink = {
  __typename?: 'SapLink';
  activeCustomerIds?: Maybe<Array<Scalars['String']>>;
  customerIds?: Maybe<Array<Scalars['String']>>;
  primaryCustomerId?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['String']>;
};

export type SearchDiscountsInput = {
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountType>;
  typeDependentValue?: InputMaybe<Scalars['UUID4']>;
};

export type ShippingConfig = {
  __typename?: 'ShippingConfig';
  fixedFeeShipping?: Maybe<Scalars['Int']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDeliveryWindowInDays?: Maybe<Scalars['Int']>;
};

export type ShoppingBagConfig = {
  __typename?: 'ShoppingBagConfig';
  availableSubscriptionIntervalsInDays: Array<Scalars['Int']>;
  maxAmountForSelect: Scalars['Int'];
  minimumPurchaseAmount: Scalars['Int'];
  minimumPurchaseQty: Scalars['Int'];
  orderSubscriptionsEnabled: Scalars['Boolean'];
  subscriptionIntervalsInDays: Array<Scalars['Int']>;
};

export type SignupInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type SignupUserInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

/** identifies the front end source of incoming data */
export enum SourceType {
  Default = 'DEFAULT',
  Footer = 'FOOTER'
}

export type StatesConfig = {
  __typename?: 'StatesConfig';
  countryId: Scalars['String'];
  statesAllowed: Array<AllowedState>;
};

export type Story = {
  __typename?: 'Story';
  appId?: Maybe<Scalars['ID']>;
  body?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  insertedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<Item>>>;
  module?: Maybe<Module>;
  moduleType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubmitOrderInput = {
  contactInfo: ContactInfoInput;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest: PaymentRequestInput;
  price: PriceInput;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type SubmittedOrder = {
  __typename?: 'SubmittedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  cartId?: Maybe<Scalars['UUID4']>;
  contactInfo: ContactInfo;
  createdOrderSubscriptions: Array<OrderSubscription>;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemStatus?: Maybe<Scalars['String']>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  orderSubscriptionRelationship: OrderSubscriptionRelationshipNames;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type SubmittedOrderPayload = {
  __typename?: 'SubmittedOrderPayload';
  pagination: PaginationData;
  submittedOrders: Array<SubmittedOrder>;
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['Int']>;
  calculatedTax?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Int']>;
  impositionTypeId?: Maybe<Scalars['Int']>;
  impositionValue?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  taxRuleId?: Maybe<Scalars['String']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  analyticsConfig: AnalyticsConfig;
  /** @deprecated Deprecated in favor of `id`. */
  appId: Scalars['UUID4'];
  brandConfig: BrandConfig;
  capabilities: Capabilities;
  checkout?: Maybe<Checkout>;
  contactConfig: ContactConfig;
  domain: Scalars['String'];
  fallbackUrl: Scalars['String'];
  giftConfig: GiftConfig;
  id: Scalars['UUID4'];
  paymentConfig: PaymentConfig;
  shippingConfig: ShippingConfig;
  shoppingBagConfig: ShoppingBagConfig;
  userExperience: UserExperience;
};

export type TenantPaymentOptions = {
  __typename?: 'TenantPaymentOptions';
  merchantAccountId?: Maybe<Scalars['String']>;
};

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type UnitAmount = {
  __typename?: 'UnitAmount';
  amount?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type UpdateCreditCardDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type UpdateOrderInput = {
  contactInfo?: InputMaybe<ContactInfoInput>;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateOrderSubscriptionAddressInput = {
  addressId: Scalars['UUID4'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type UpdateOrderSubscriptionInput = {
  id: Scalars['UUID4'];
  intervalInDays?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderSubscriptionPaymentInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  paymentOptions?: InputMaybe<PaymentOptionsInput>;
};

export type UpdateOrderSubscriptionStatusInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  status: OrderSubscriptionStatusNames;
  /** This field is required if status is PAUSED or CANCELED */
  statusReason?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentMethodDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  addresses: Array<Address>;
  /** @deprecated Legacy admin has been disabled, this field is now always false. */
  admin: Scalars['Boolean'];
  appId: Scalars['UUID4'];
  cart?: Maybe<Cart>;
  /** @deprecated Please use paymentMethods going forward. */
  creditCards: Array<CreditCard>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hashedEmail: Scalars['String'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  lastLoggedIn?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<PaymentMethods>;
  vendorConfig: Tenant;
};

export type UserAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type UserAddressIsDefaultInput = {
  isDefault: Scalars['Boolean'];
};

export type UserExperience = {
  __typename?: 'UserExperience';
  hasRequestedDeliveryDate: Scalars['Boolean'];
};

export type UserPasswordResetRequestPayload = {
  __typename?: 'UserPasswordResetRequestPayload';
  email: Scalars['String'];
};

export type ValidateZipcodePayload = {
  __typename?: 'ValidateZipcodePayload';
  restrictedItems: Array<Item>;
};

export enum ValidationRequirement {
  Always = 'ALWAYS',
  Optional = 'OPTIONAL'
}

export type VerifyAddressError = {
  __typename?: 'VerifyAddressError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  suggestion?: Maybe<Scalars['String']>;
};

export type VerifyAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type VerifyAddressPayload = {
  __typename?: 'VerifyAddressPayload';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  errors?: Maybe<Array<VerifyAddressError>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type AssociateCartToUserMutationVariables = Exact<{
  cartId: Scalars['UUID4'];
}>;


export type AssociateCartToUserMutation = { __typename?: 'RootMutationType', associateCartToUser?: { __typename?: 'Cart', appId: any, id: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined };

export type CartFragment = { __typename?: 'Cart', appId: any, id: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> };

export type CartQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type CartQuery = { __typename?: 'RootQueryType', cart?: { __typename?: 'Cart', appId: any, id: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any } | null | undefined };

export type EmailNewsletterSignupMutationVariables = Exact<{
  input: EmailNewsletterSignupInput;
}>;


export type EmailNewsletterSignupMutation = { __typename?: 'RootMutationType', emailNewsletterSignup?: string | null | undefined };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'RootQueryType', featureFlags: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean }> };

export type GetCartFromUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartFromUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', cart?: { __typename?: 'Cart', appId: any, id: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined } | null | undefined };

export type GetItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemsQuery = { __typename?: 'RootQueryType', getItems?: { __typename?: 'ItemsPayload', items: Array<{ __typename?: 'Item', gtin: string, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined }> } | null | undefined };

export type ItemByGtinQueryVariables = Exact<{
  gtin: Scalars['String'];
}>;


export type ItemByGtinQuery = { __typename?: 'RootQueryType', itemByGtin?: { __typename?: 'Item', brandName?: string | null | undefined, price?: number | null | undefined, caloriesPerPack?: any | null | undefined, id: any, title?: string | null | undefined, slug?: string | null | undefined, description?: string | null | undefined, dimensions?: string | null | undefined, returnsPolicy?: string | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, imgUrl?: string | null | undefined, material?: string | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemDesignerArtistBrandName?: string | null | undefined, itemDimensions?: string | null | undefined, categories?: Array<{ __typename?: 'Category', level1?: string | null | undefined, level2?: string | null | undefined, level3?: string | null | undefined } | null | undefined> | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, recommendedItems: Array<{ __typename?: 'Item', compareAtPrice: number, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, productsPerPack?: number | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemSlug?: string | null | undefined, itemImgUrl?: string | null | undefined }>, nutritionData?: { __typename?: 'NutritionData', ingredientsTextEn?: string | null | undefined } | null | undefined, imgVariantUrls?: Array<{ __typename?: 'ProductImageVariant', pos?: number | null | undefined, src?: string | null | undefined } | null | undefined> | null | undefined, variantOptions?: Array<{ __typename?: 'ProductVariant', variant?: { __typename?: 'Item', slug?: string | null | undefined } | null | undefined, variantOptions?: Array<{ __typename?: 'ProductVariantOption', name?: string | null | undefined, value?: string | null | undefined, position?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ItemBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ItemBySlugQuery = { __typename?: 'RootQueryType', itemBySlug?: { __typename?: 'Item', brandName?: string | null | undefined, price?: number | null | undefined, caloriesPerPack?: any | null | undefined, id: any, title?: string | null | undefined, slug?: string | null | undefined, description?: string | null | undefined, dimensions?: string | null | undefined, returnsPolicy?: string | null | undefined, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, imgUrl?: string | null | undefined, material?: string | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemDesignerArtistBrandName?: string | null | undefined, itemDimensions?: string | null | undefined, categories?: Array<{ __typename?: 'Category', level1?: string | null | undefined, level2?: string | null | undefined, level3?: string | null | undefined } | null | undefined> | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, recommendedItems: Array<{ __typename?: 'Item', compareAtPrice: number, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, productsPerPack?: number | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemSlug?: string | null | undefined, itemImgUrl?: string | null | undefined }>, nutritionData?: { __typename?: 'NutritionData', ingredientsTextEn?: string | null | undefined } | null | undefined, imgVariantUrls?: Array<{ __typename?: 'ProductImageVariant', pos?: number | null | undefined, src?: string | null | undefined } | null | undefined> | null | undefined, variantOptions?: Array<{ __typename?: 'ProductVariant', variant?: { __typename?: 'Item', slug?: string | null | undefined } | null | undefined, variantOptions?: Array<{ __typename?: 'ProductVariantOption', name?: string | null | undefined, value?: string | null | undefined, position?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ItemFieldsForAnalyticsFragment = { __typename?: 'Item', _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemDesignerArtistBrandName?: string | null | undefined, itemDimensions?: string | null | undefined };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'RootMutationType', login?: { __typename?: 'User', id: any, admin: boolean, email: string } | null | undefined };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'RootMutationType', logoutUser?: { __typename?: 'User', id: any } | null | undefined };

export type ModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ModulesQuery = { __typename?: 'RootQueryType', modules: Array<{ __typename?: 'Module', id: any, title1?: string | null | undefined, cta1?: string | null | undefined, storySlug: string, urlOverride?: string | null | undefined, type: string, publishedAt?: any | null | undefined, thumbnailItems: Array<{ __typename?: 'ModuleThumbnailItem', imgUrl?: string | null | undefined, position?: number | null | undefined }> }> };

export type RecommendedProductFragment = { __typename?: 'Item', compareAtPrice: number, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, productsPerPack?: number | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemSlug?: string | null | undefined, itemImgUrl?: string | null | undefined };

export type RequestPasswordResetForUserMutationVariables = Exact<{
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
}>;


export type RequestPasswordResetForUserMutation = { __typename?: 'RootMutationType', requestPasswordResetForUser?: { __typename?: 'RequestPasswordResetForUserPayload', email: string } | null | undefined };

export type RestrictedItemsByZipCodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type RestrictedItemsByZipCodeQuery = { __typename?: 'RootQueryType', restrictedItemsByZipCode?: { __typename?: 'RestrictedItemsByZipCodePayload', restrictedItems: Array<{ __typename?: 'Item', id: any }> } | null | undefined };

export type SignUpUserMutationVariables = Exact<{
  activationCode: Scalars['String'];
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type SignUpUserMutation = { __typename?: 'RootMutationType', signupUser?: { __typename?: 'User', id: any, admin: boolean, email: string } | null | undefined };

export type StoryBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type StoryBySlugQuery = { __typename?: 'RootQueryType', story?: { __typename?: 'Story', slug?: string | null | undefined, title1?: string | null | undefined, title2?: string | null | undefined, items?: Array<{ __typename?: 'Item', compareAtPrice: number, isOutOfStock?: boolean | null | undefined, inventoryQty?: number | null | undefined, minOrderQty?: number | null | undefined, itemSlug?: string | null | undefined, itemImgUrl?: string | null | undefined, _id: any, itemTitle?: string | null | undefined, itemPrice?: number | null | undefined, itemDesignerArtistBrandName?: string | null | undefined, itemDimensions?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'RootQueryType', tenant?: { __typename?: 'Tenant', brandConfig: { __typename?: 'BrandConfig', title: string, customizations: { __typename?: 'BrandConfigCustomizations', fonts: Array<{ __typename?: 'BrandConfigCustomizationsFont', name: string, style?: string | null | undefined, weight?: string | null | undefined, urls: Array<{ __typename?: 'BrandConfigCustomizationsFontSources', format?: string | null | undefined, local?: string | null | undefined, url?: string | null | undefined }>, meta?: Array<{ __typename?: 'BrandConfigCustomizationsFontMeta', key: string, value: string }> | null | undefined }> }, trackingFonts?: Array<{ __typename?: 'BrandConfigTrackingFonts', isTrackingRequired: boolean, resource: string } | null | undefined> | null | undefined }, shoppingBagConfig: { __typename?: 'ShoppingBagConfig', maxAmountForSelect: number, minimumPurchaseAmount: number, availableSubscriptionIntervalsInDays: Array<number>, orderSubscriptionsEnabled: boolean, subscriptionIntervalsInDays: Array<number> } } | null | undefined };

export type UpdateCartItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCartItemMutation = { __typename?: 'RootMutationType', updateCartItem?: { __typename?: 'Cart', appId: any, id: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined };

export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  appId
  id
  user {
    id
  }
  items {
    id
    quantity
    product: item {
      id
      itemSlug: slug
      gtin
      title
      brandName
      imgUrl
      price
      isOutOfStock
      minOrderQty
      inventoryQty
      compareAtPrice
      subscriptionMetadata {
        discount {
          id
          activeFrom
          amount
          isPercent
        }
        isSubscribable
        subscriptionPrice
      }
    }
    subscriptionIntervalInDays
  }
}
    `;
export const ItemFieldsForAnalyticsFragmentDoc = gql`
    fragment ItemFieldsForAnalytics on Item {
  _id: id
  itemTitle: title
  itemPrice: price
  itemDesignerArtistBrandName: brandName
  itemDimensions: dimensions
}
    `;
export const RecommendedProductFragmentDoc = gql`
    fragment RecommendedProduct on Item {
  _id: id
  itemTitle: title
  compareAtPrice
  itemPrice: price
  isOutOfStock
  itemSlug: slug
  itemImgUrl: imgUrl
  inventoryQty
  minOrderQty
  productsPerPack
}
    `;
export const AssociateCartToUserDocument = gql`
    mutation AssociateCartToUser($cartId: UUID4!) {
  associateCartToUser(cartId: $cartId) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type AssociateCartToUserMutationFn = Apollo.MutationFunction<AssociateCartToUserMutation, AssociateCartToUserMutationVariables>;

/**
 * __useAssociateCartToUserMutation__
 *
 * To run a mutation, you first call `useAssociateCartToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateCartToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateCartToUserMutation, { data, loading, error }] = useAssociateCartToUserMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAssociateCartToUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssociateCartToUserMutation, AssociateCartToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssociateCartToUserMutation, AssociateCartToUserMutationVariables>(AssociateCartToUserDocument, options);
      }
export type AssociateCartToUserMutationHookResult = ReturnType<typeof useAssociateCartToUserMutation>;
export type AssociateCartToUserMutationResult = Apollo.MutationResult<AssociateCartToUserMutation>;
export type AssociateCartToUserMutationOptions = Apollo.BaseMutationOptions<AssociateCartToUserMutation, AssociateCartToUserMutationVariables>;
export const CartDocument = gql`
    query Cart($id: UUID4!) {
  cart(id: $id) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const EmailNewsletterSignupDocument = gql`
    mutation emailNewsletterSignup($input: EmailNewsletterSignupInput!) {
  emailNewsletterSignup(input: $input)
}
    `;
export type EmailNewsletterSignupMutationFn = Apollo.MutationFunction<EmailNewsletterSignupMutation, EmailNewsletterSignupMutationVariables>;

/**
 * __useEmailNewsletterSignupMutation__
 *
 * To run a mutation, you first call `useEmailNewsletterSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailNewsletterSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailNewsletterSignupMutation, { data, loading, error }] = useEmailNewsletterSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailNewsletterSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailNewsletterSignupMutation, EmailNewsletterSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailNewsletterSignupMutation, EmailNewsletterSignupMutationVariables>(EmailNewsletterSignupDocument, options);
      }
export type EmailNewsletterSignupMutationHookResult = ReturnType<typeof useEmailNewsletterSignupMutation>;
export type EmailNewsletterSignupMutationResult = Apollo.MutationResult<EmailNewsletterSignupMutation>;
export type EmailNewsletterSignupMutationOptions = Apollo.BaseMutationOptions<EmailNewsletterSignupMutation, EmailNewsletterSignupMutationVariables>;
export const FeatureFlagsDocument = gql`
    query FeatureFlags {
  featureFlags {
    name
    enabled
  }
}
    `;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const GetCartFromUserDocument = gql`
    query GetCartFromUser {
  currentUser {
    cart {
      ...Cart
    }
  }
}
    ${CartFragmentDoc}`;

/**
 * __useGetCartFromUserQuery__
 *
 * To run a query within a React component, call `useGetCartFromUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartFromUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartFromUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartFromUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCartFromUserQuery, GetCartFromUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCartFromUserQuery, GetCartFromUserQueryVariables>(GetCartFromUserDocument, options);
      }
export function useGetCartFromUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCartFromUserQuery, GetCartFromUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCartFromUserQuery, GetCartFromUserQueryVariables>(GetCartFromUserDocument, options);
        }
export type GetCartFromUserQueryHookResult = ReturnType<typeof useGetCartFromUserQuery>;
export type GetCartFromUserLazyQueryHookResult = ReturnType<typeof useGetCartFromUserLazyQuery>;
export type GetCartFromUserQueryResult = Apollo.QueryResult<GetCartFromUserQuery, GetCartFromUserQueryVariables>;
export const GetItemsDocument = gql`
    query getItems {
  getItems(pagination: {page: 1, limit: 100}) {
    items {
      gtin
      price
      isOutOfStock
      inventoryQty
    }
  }
}
    `;

/**
 * __useGetItemsQuery__
 *
 * To run a query within a React component, call `useGetItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemsQuery, GetItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetItemsQuery, GetItemsQueryVariables>(GetItemsDocument, options);
      }
export function useGetItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemsQuery, GetItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetItemsQuery, GetItemsQueryVariables>(GetItemsDocument, options);
        }
export type GetItemsQueryHookResult = ReturnType<typeof useGetItemsQuery>;
export type GetItemsLazyQueryHookResult = ReturnType<typeof useGetItemsLazyQuery>;
export type GetItemsQueryResult = Apollo.QueryResult<GetItemsQuery, GetItemsQueryVariables>;
export const ItemByGtinDocument = gql`
    query ItemByGtin($gtin: String!) {
  itemByGtin(gtin: $gtin) {
    ...ItemFieldsForAnalytics
    brandName
    price
    caloriesPerPack
    id
    title
    slug
    description
    dimensions
    returnsPolicy
    isOutOfStock
    inventoryQty
    minOrderQty
    imgUrl
    material
    categories {
      level1
      level2
      level3
    }
    subscriptionMetadata {
      isSubscribable
      subscriptionPrice
      discount {
        id
        activeFrom
        amount
        isPercent
      }
    }
    recommendedItems {
      ...RecommendedProduct
    }
    nutritionData {
      ingredientsTextEn
    }
    imgVariantUrls {
      pos
      src
    }
    variantOptions {
      variant {
        slug
      }
      variantOptions {
        name
        value
        position
      }
    }
  }
}
    ${ItemFieldsForAnalyticsFragmentDoc}
${RecommendedProductFragmentDoc}`;

/**
 * __useItemByGtinQuery__
 *
 * To run a query within a React component, call `useItemByGtinQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemByGtinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemByGtinQuery({
 *   variables: {
 *      gtin: // value for 'gtin'
 *   },
 * });
 */
export function useItemByGtinQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemByGtinQuery, ItemByGtinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemByGtinQuery, ItemByGtinQueryVariables>(ItemByGtinDocument, options);
      }
export function useItemByGtinLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemByGtinQuery, ItemByGtinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemByGtinQuery, ItemByGtinQueryVariables>(ItemByGtinDocument, options);
        }
export type ItemByGtinQueryHookResult = ReturnType<typeof useItemByGtinQuery>;
export type ItemByGtinLazyQueryHookResult = ReturnType<typeof useItemByGtinLazyQuery>;
export type ItemByGtinQueryResult = Apollo.QueryResult<ItemByGtinQuery, ItemByGtinQueryVariables>;
export const ItemBySlugDocument = gql`
    query ItemBySlug($slug: String!) {
  itemBySlug(slug: $slug) {
    ...ItemFieldsForAnalytics
    brandName
    price
    caloriesPerPack
    id
    title
    slug
    description
    dimensions
    returnsPolicy
    isOutOfStock
    inventoryQty
    minOrderQty
    imgUrl
    material
    categories {
      level1
      level2
      level3
    }
    subscriptionMetadata {
      isSubscribable
      subscriptionPrice
      discount {
        id
        activeFrom
        amount
        isPercent
      }
    }
    recommendedItems {
      ...RecommendedProduct
    }
    nutritionData {
      ingredientsTextEn
    }
    imgVariantUrls {
      pos
      src
    }
    variantOptions {
      variant {
        slug
      }
      variantOptions {
        name
        value
        position
      }
    }
  }
}
    ${ItemFieldsForAnalyticsFragmentDoc}
${RecommendedProductFragmentDoc}`;

/**
 * __useItemBySlugQuery__
 *
 * To run a query within a React component, call `useItemBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useItemBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemBySlugQuery, ItemBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemBySlugQuery, ItemBySlugQueryVariables>(ItemBySlugDocument, options);
      }
export function useItemBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemBySlugQuery, ItemBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemBySlugQuery, ItemBySlugQueryVariables>(ItemBySlugDocument, options);
        }
export type ItemBySlugQueryHookResult = ReturnType<typeof useItemBySlugQuery>;
export type ItemBySlugLazyQueryHookResult = ReturnType<typeof useItemBySlugLazyQuery>;
export type ItemBySlugQueryResult = Apollo.QueryResult<ItemBySlugQuery, ItemBySlugQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(input: {email: $email, password: $password}) {
    id
    admin
    email
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    id
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const ModulesDocument = gql`
    query Modules {
  modules {
    id
    title1
    cta1
    storySlug
    urlOverride
    type
    publishedAt
    thumbnailItems {
      imgUrl
      position
    }
  }
}
    `;

/**
 * __useModulesQuery__
 *
 * To run a query within a React component, call `useModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useModulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModulesQuery, ModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModulesQuery, ModulesQueryVariables>(ModulesDocument, options);
      }
export function useModulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModulesQuery, ModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModulesQuery, ModulesQueryVariables>(ModulesDocument, options);
        }
export type ModulesQueryHookResult = ReturnType<typeof useModulesQuery>;
export type ModulesLazyQueryHookResult = ReturnType<typeof useModulesLazyQuery>;
export type ModulesQueryResult = Apollo.QueryResult<ModulesQuery, ModulesQueryVariables>;
export const RequestPasswordResetForUserDocument = gql`
    mutation requestPasswordResetForUser($email: String!, $state: String) {
  requestPasswordResetForUser(input: {email: $email, state: $state}) {
    email
  }
}
    `;
export type RequestPasswordResetForUserMutationFn = Apollo.MutationFunction<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;

/**
 * __useRequestPasswordResetForUserMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetForUserMutation, { data, loading, error }] = useRequestPasswordResetForUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useRequestPasswordResetForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>(RequestPasswordResetForUserDocument, options);
      }
export type RequestPasswordResetForUserMutationHookResult = ReturnType<typeof useRequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationResult = Apollo.MutationResult<RequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;
export const RestrictedItemsByZipCodeDocument = gql`
    query RestrictedItemsByZipCode($zip: String!) {
  restrictedItemsByZipCode(zip: $zip) {
    restrictedItems {
      id
    }
  }
}
    `;

/**
 * __useRestrictedItemsByZipCodeQuery__
 *
 * To run a query within a React component, call `useRestrictedItemsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedItemsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedItemsByZipCodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useRestrictedItemsByZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
      }
export function useRestrictedItemsByZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
        }
export type RestrictedItemsByZipCodeQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeQuery>;
export type RestrictedItemsByZipCodeLazyQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeLazyQuery>;
export type RestrictedItemsByZipCodeQueryResult = Apollo.QueryResult<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($activationCode: String!, $activationCodeRequired: Boolean, $dateOfBirth: Date, $email: String!, $emailOptIn: Boolean, $password: String!, $passwordConfirmation: String!) {
  signupUser(
    input: {activationCode: $activationCode, activationCodeRequired: $activationCodeRequired, dateOfBirth: $dateOfBirth, email: $email, emailOptIn: $emailOptIn, password: $password, passwordConfirmation: $passwordConfirmation}
  ) {
    id
    admin
    email
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *      activationCodeRequired: // value for 'activationCodeRequired'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      email: // value for 'email'
 *      emailOptIn: // value for 'emailOptIn'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const StoryBySlugDocument = gql`
    query StoryBySlug($slug: String!) {
  story: storyBySlug(slug: $slug) {
    slug
    title1
    title2
    items {
      ...ItemFieldsForAnalytics
      compareAtPrice
      isOutOfStock
      itemSlug: slug
      itemImgUrl: imgUrl
      inventoryQty
      minOrderQty
    }
  }
}
    ${ItemFieldsForAnalyticsFragmentDoc}`;

/**
 * __useStoryBySlugQuery__
 *
 * To run a query within a React component, call `useStoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStoryBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoryBySlugQuery, StoryBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoryBySlugQuery, StoryBySlugQueryVariables>(StoryBySlugDocument, options);
      }
export function useStoryBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoryBySlugQuery, StoryBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoryBySlugQuery, StoryBySlugQueryVariables>(StoryBySlugDocument, options);
        }
export type StoryBySlugQueryHookResult = ReturnType<typeof useStoryBySlugQuery>;
export type StoryBySlugLazyQueryHookResult = ReturnType<typeof useStoryBySlugLazyQuery>;
export type StoryBySlugQueryResult = Apollo.QueryResult<StoryBySlugQuery, StoryBySlugQueryVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    brandConfig {
      title
      customizations {
        fonts {
          name
          style
          urls {
            format
            local
            url
          }
          weight
          meta {
            key
            value
          }
        }
      }
      trackingFonts {
        isTrackingRequired
        resource
      }
    }
    shoppingBagConfig {
      maxAmountForSelect
      minimumPurchaseAmount
      availableSubscriptionIntervalsInDays
      orderSubscriptionsEnabled
      subscriptionIntervalsInDays
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($id: UUID4, $itemId: UUID4!, $quantity: Int!, $subscriptionIntervalInDays: Int) {
  updateCartItem(
    input: {id: $id, itemId: $itemId, quantity: $quantity, subscriptionIntervalInDays: $subscriptionIntervalInDays}
  ) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type UpdateCartItemMutationFn = Apollo.MutationFunction<UpdateCartItemMutation, UpdateCartItemMutationVariables>;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemMutation, { data, loading, error }] = useUpdateCartItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      itemId: // value for 'itemId'
 *      quantity: // value for 'quantity'
 *      subscriptionIntervalInDays: // value for 'subscriptionIntervalInDays'
 *   },
 * });
 */
export function useUpdateCartItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
      }
export type UpdateCartItemMutationHookResult = ReturnType<typeof useUpdateCartItemMutation>;
export type UpdateCartItemMutationResult = Apollo.MutationResult<UpdateCartItemMutation>;
export type UpdateCartItemMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>;